import {
  mdiDeleteOutline,
  mdiContentCopy,
  mdiArrowExpandLeft,
  mdiArrowExpandRight,
  mdiMagnify,
  mdiPuzzle,
  mdiChevronUp,
  mdiChevronRight,
  mdiChevronLeft,
  mdiChevronDown,
  mdiWidgets,
  mdiPencilOutline,
  mdiPlus,
  mdiDragHorizontal,
  mdiFolderMultipleImage,
  mdiCheck,
  mdiClose,
  mdiLinkVariant,
  mdiFilterVariant,
  mdiPlay,
  mdiPause,
  mdiRepeat,
  mdiRecordCircleOutline,
  mdiMicrophone,
  mdiMonitor,
  mdiStar,
  mdiPlayCircle,
  mdiFormatListBulletedSquare,
  mdiTimerOutline,
  mdiImage,
  mdiVideo,
  mdiMusic,
  mdiMusicNote,
  mdiBowTie,
  mdiPlusCircle,
  mdiCog,
  mdiViewList,
  mdiAccountMultiple,
  mdiUnfoldMoreHorizontal,
  mdiUnfoldLessHorizontal,
  mdiVolumeHigh,
  mdiKeyboard,
  mdiLayers,
  mdiRefresh,
  mdiHistory,
  mdiDownload,
} from '@mdi/js'

import IconFactory from './IconFactory'

export const TrashIcon = IconFactory.create(
  mdiDeleteOutline,
  'Trash Can',
  'TrashIcon'
)
export const CopyIcon = IconFactory.create(mdiContentCopy, 'Copy', 'CopyIcon')
export const ArrowExpandLeftIcon = IconFactory.create(
  mdiArrowExpandLeft,
  'Arrow Expand Left',
  'ArrowExpandLeftIcon'
)
export const ArrowExpandRightIcon = IconFactory.create(
  mdiArrowExpandRight,
  'Arrow Expand Right',
  'ArrowExpandRightIcon'
)
export const MagnifyIcon = IconFactory.create(
  mdiMagnify,
  'Magnify',
  'MagnifyIcon'
)
export const PuzzleIcon = IconFactory.create(mdiPuzzle, 'Puzzle', 'PuzzleIcon')
export const ChevronUpIcon = IconFactory.create(
  mdiChevronUp,
  'Chevron Up',
  'ChevronUpIcon'
)
export const ChevronRightIcon = IconFactory.create(
  mdiChevronRight,
  'Chevron Right',
  'ChevronRightIcon'
)
export const ChevronLeftIcon = IconFactory.create(
  mdiChevronLeft,
  'Chevron Left',
  'ChevronLeftIcon'
)
export const ChevronDownIcon = IconFactory.create(
  mdiChevronDown,
  'Chevron Down',
  'ChevronDownIcon'
)
export const WidgetsIcon = IconFactory.create(
  mdiWidgets,
  'Widgets',
  'WidgetsIcon'
)
export const PencilIcon = IconFactory.create(
  mdiPencilOutline,
  'Pencil',
  'PencilIcon'
)
export const PlusIcon = IconFactory.create(mdiPlus, 'Plus', 'PlusIcon')
export const DragIcon = IconFactory.create(
  mdiDragHorizontal,
  'Drag',
  'DragIcon'
)
export const MediaIcon = IconFactory.create(
  mdiFolderMultipleImage,
  'Media',
  'MediaIcon'
)
export const CheckIcon = IconFactory.create(mdiCheck, 'Check', 'CheckIcon')
export const CloseIcon = IconFactory.create(mdiClose, 'Close', 'CloseIcon')
export const LinkIcon = IconFactory.create(mdiLinkVariant, 'Link', 'LinkIcon')
export const FilterIcon = IconFactory.create(
  mdiFilterVariant,
  'Filter',
  'FilterIcon'
)
export const PlayIcon = IconFactory.create(mdiPlay, 'Play', 'PlayIcon')
export const PauseIcon = IconFactory.create(mdiPause, 'Pause', 'PauseIcon')
export const RepeatIcon = IconFactory.create(mdiRepeat, 'Repeat', 'RepeatIcon')
export const RecordIcon = IconFactory.create(
  mdiRecordCircleOutline,
  'Record',
  'RecordIcon'
)
export const MicrophoneIcon = IconFactory.create(
  mdiMicrophone,
  'Microphone',
  'MicrophoneIcon'
)
export const MonitorIcon = IconFactory.create(
  mdiMonitor,
  'Monitor',
  'MonitorIcon'
)
export const StarIcon = IconFactory.create(mdiStar, 'Star', 'StarIcon')
export const PlayCircleIcon = IconFactory.create(
  mdiPlayCircle,
  'Play',
  'PlayIcon'
)
export const ListIcon = IconFactory.create(
  mdiFormatListBulletedSquare,
  'List',
  'ListIcon'
)
export const TimerIcon = IconFactory.create(
  mdiTimerOutline,
  'Timer',
  'TimerIcon'
)
export const ImageIcon = IconFactory.create(mdiImage, 'Image', 'ImageIcon')
export const VideoIcon = IconFactory.create(mdiVideo, 'Video', 'VideoIcon')
export const MusicIcon = IconFactory.create(mdiMusic, 'Music', 'MusicIcon')
export const ListBoxIcon = IconFactory.create(
  mdiViewList,
  'ListBox',
  'ListBoxIcon'
)
export const MusicNoteIcon = IconFactory.create(
  mdiMusicNote,
  'MusicNote',
  'MusicNoteIcon'
)
export const PlusCircleIcon = IconFactory.create(
  mdiPlusCircle,
  'PlusCircle',
  'PlusCircleIcon'
)
export const BowTieIcon = IconFactory.create(mdiBowTie, 'BowTie', 'BowTieIcon')
export const CogIcon = IconFactory.create(mdiCog, 'Cog', 'CogIcon')
export const AccountMultiple = IconFactory.create(
  mdiAccountMultiple,
  'AccountMultiple',
  'AccountMultipleIcon'
)
export const UnfoldMoreIcon = IconFactory.create(
  mdiUnfoldMoreHorizontal,
  'Unfold',
  'UnfoldMoreIcon'
)
export const UnfoldLessIcon = IconFactory.create(
  mdiUnfoldLessHorizontal,
  'Unfold',
  'UnfoldLessIcon'
)
export const VolumeIcon = IconFactory.create(
  mdiVolumeHigh,
  'Volume',
  'VolumeIcon'
)
export const KeyboardIcon = IconFactory.create(
  mdiKeyboard,
  'Keyboard',
  'KeyboardIcon'
)
export const LayersIcon = IconFactory.create(mdiLayers, 'Layers', 'LayersIcon')
export const RefreshIcon = IconFactory.create(
  mdiRefresh,
  'Refresh',
  'RefreshIcon'
)
export const HistoryIcon = IconFactory.create(
  mdiHistory,
  'History',
  'HistoryIcon'
)
export const IconDownload = IconFactory.create(
  mdiDownload,
  'Download',
  'IconDownload'
)
